import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import Form from './clienteVendedorForm';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import DateFormat from '../common/dateFormat/DateFormat';
import Grid from '../common/layout/grid';

import {
	setModoTela,
	initForm,
	salvar,
	excluir,
	reservarCliente,
	getLista,
	setFiltro,
	getRegistro,
	getListaClienteTipo,
	getListaClienteStatus,
	getListaEstadoCivil,
	getListaFormaPagamento,
	getListaOperadoraTelefonica,
	getListaTipoContrato,
	getListaUsuario,
	getListaEstado,
	getListaCidade
} from './clienteVendedorActions';

class ClienteVendedor extends Component {

	state = {
		pesquisar: ''
	};

	componentDidMount() {
		setModoTela('lista');
		this.props.getLista(true);
		this.props.getListaClienteTipo();
		this.props.getListaClienteStatus();
		this.props.getListaEstadoCivil();
		this.props.getListaFormaPagamento();
		this.props.getListaOperadoraTelefonica();
		this.props.getListaTipoContrato();
		this.props.getListaUsuario();
		this.props.getListaEstado();
		this.props.getListaCidade();
	}

	getRegistroInicial = () => ({
		id_tipo: 1,
		data_venda: DateFormat.formatarDataSqlParaTela(
			DateFormat.getDataAtual()
		),
		id_status: 4,
		id_representante: this.props.sessao.id,
		id_vendedor: this.props.sessao.id
	});

	adicionar = () => {
		const registro = this.getRegistroInicial();

		this.props.setModoTela('cadastro', registro);
		this.props.initForm(registro);
	};

	getListaFiltrada = () => {
		const pesquisar = (this.state.pesquisar || '')
			.trim()
			.toUpperCase();

		return (this.props.lista || [])
			.filter(item => Number(item.id_tipo) === 1)
			.filter(item => {
				if (!pesquisar) {
					return true;
				}

				const texto = [
					item.numero_contrato,
					item.nome,
					item.cpf,
					item.telefone_fixo,
					item.celular1,
					item.celular2,
					item.nome_status
				]
					.filter(valor => valor !== null && valor !== undefined)
					.join(' ')
					.toUpperCase();

				return texto.includes(pesquisar);
			});
	};

	renderStatus = item => (
		<span
			className="cliente-vendedor-status"
			style={{
				color: item.cor_status || '#495057',
				backgroundColor: `${item.cor_status || '#495057'}18`,
				borderColor: `${item.cor_status || '#495057'}40`
			}}
		>
			<span
				className="cliente-vendedor-status-ponto"
				style={{
					backgroundColor: item.cor_status || '#495057'
				}}
			/>

			{item.nome_status || 'Sem status'}
		</span>
	);

	renderCardsMobile = lista => (
		<div className="cliente-vendedor-cards-mobile">
			{lista.map(item => (
				<div
					key={item.id}
					className="cliente-vendedor-card-mobile"
					onClick={() => {
						this.props.getRegistro(item.id, 'visualizacao');
					}}
				>
					<div className="cliente-vendedor-card-topo">
						<div>
							<div className="cliente-vendedor-card-numero">
								<i className="fa fa-ticket-alt" />

								<span>
									Cliente: {item.numero_cliente || '-'}
								</span>
							</div>

							<div className="cliente-vendedor-card-data">
								<i className="fa fa-calendar-alt" />

								{item.data_venda
									? DateFormat.formatarDataSqlParaTela(item.data_venda)
									: '-'}
							</div>
						</div>

						<div>
							{this.renderStatus(item)}
						</div>
					</div>

					<div className="cliente-vendedor-card-divisor" />

					<div className="cliente-vendedor-card-nome">
						<div>
							<span className="cliente-vendedor-card-label">
								Nome:
							</span>

							<strong>
								{item.nome || 'Nome não informado'}
							</strong>
						</div>
					</div>

					{item.cpf &&
						<div className="cliente-vendedor-card-info">
							<i className="fa fa-id-card" />

							<span>
								{item.cpf}
							</span>
						</div>
					}
				</div>
			))}
		</div>
	);

	renderTabelaDesktop = lista => (
		<div className="cliente-vendedor-tabela-desktop">
			<Table responsive>
				<THead>
					<Tr>
						<Th>Data</Th>
						<Th alignCenter>Status</Th>
						<Th>Número</Th>
						<Th>Nome</Th>
					</Tr>
				</THead>

				<TBody>
					{lista.map(item => (
						<Tr key={item.id}>
							<Td>
								{item.data_venda
									? DateFormat.formatarDataSqlParaTela(item.data_venda)
									: '-'}
							</Td>

							<Td alignCenter>
								{this.renderStatus(item)}
							</Td>

							<Td>
								<strong>
									{item.numero_contrato || '-'}
								</strong>
							</Td>

							<Td>
								{item.nome || '-'}
							</Td>
						</Tr>
					))}
				</TBody>
			</Table>
		</div>
	);

	renderListaVazia = () => (
		<div className="cliente-vendedor-vazio">
			<div className="cliente-vendedor-vazio-icone">
				<i className="fa fa-ticket-alt" />
			</div>

			<strong>Nenhum cliente encontrado</strong>

			<span>
				Altere os filtros ou cadastre um novo cliente.
			</span>
		</div>
	);

	lista = () => {
		const lista = this.getListaFiltrada();

		return (
			<>
				<style>
					{`
						.cliente-vendedor-acoes {
							display: flex;
							align-items: center;
							justify-content: space-between;
							gap: 12px;
							margin-bottom: 18px;
						}

						.cliente-vendedor-titulo-lista {
							display: flex;
							flex-direction: column;
							gap: 2px;
						}

						.cliente-vendedor-titulo-lista strong {
							font-size: 18px;
							color: #263238;
						}

						.cliente-vendedor-titulo-lista span {
							font-size: 13px;
							color: #7b8794;
						}

						.cliente-vendedor-btn-adicionar {
							min-height: 42px;
						}

						.cliente-vendedor-filtros {
							background: #f8fafc;
							border: 1px solid #e8edf3;
							border-radius: 12px;
							padding: 16px;
							margin-bottom: 16px;
						}

						.cliente-vendedor-filtros-datas {
							display: flex;
							align-items: flex-end;
							gap: 12px;
						}

						.cliente-vendedor-filtro-data {
							flex: 1;
							min-width: 0;
						}

						.cliente-vendedor-filtro-botao {
							flex: 0 0 auto;
							padding-bottom: 15px;
						}

						.cliente-vendedor-pesquisa {
							position: relative;
							margin-top: 2px;
						}

						.cliente-vendedor-pesquisa i {
							position: absolute;
							top: 50%;
							left: 14px;
							transform: translateY(-50%);
							color: #8795a5;
							z-index: 2;
						}

						.cliente-vendedor-pesquisa input {
							height: 44px;
							padding-left: 42px;
							padding-right: 42px;
							border-radius: 10px;
							border: 1px solid #dfe5ec;
							box-shadow: none;
						}

						.cliente-vendedor-pesquisa input:focus {
							border-color: #3c8dbc;
							box-shadow: 0 0 0 3px rgba(60, 141, 188, 0.12);
						}

						.cliente-vendedor-pesquisa-limpar {
							position: absolute;
							top: 50%;
							right: 8px;
							transform: translateY(-50%);
							width: 30px;
							height: 30px;
							border: none;
							border-radius: 50%;
							background: transparent;
							color: #8995a3;
							cursor: pointer;
						}

						.cliente-vendedor-pesquisa-limpar:hover {
							background: #edf1f5;
							color: #34495e;
						}

						.cliente-vendedor-resumo {
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin: 16px 0 10px;
							color: #687583;
							font-size: 13px;
						}

						.cliente-vendedor-status {
							display: inline-flex;
							align-items: center;
							justify-content: center;
							gap: 6px;
							padding: 5px 10px;
							border: 1px solid;
							border-radius: 20px;
							font-size: 11px;
							font-weight: 700;
							white-space: nowrap;
						}

						.cliente-vendedor-status-ponto {
							width: 7px;
							height: 7px;
							border-radius: 50%;
							flex-shrink: 0;
						}

						.cliente-vendedor-cards-mobile {
							display: none;
						}

						.cliente-vendedor-btn-visualizar {
							width: 34px;
							height: 34px;
							border-radius: 8px;
						}

						.cliente-vendedor-vazio {
							display: flex;
							flex-direction: column;
							align-items: center;
							justify-content: center;
							text-align: center;
							padding: 45px 20px;
							color: #7a8794;
						}

						.cliente-vendedor-vazio-icone {
							display: flex;
							align-items: center;
							justify-content: center;
							width: 60px;
							height: 60px;
							margin-bottom: 12px;
							border-radius: 50%;
							background: #eef3f7;
							color: #6c7b89;
							font-size: 24px;
						}

						.cliente-vendedor-vazio strong {
							margin-bottom: 4px;
							color: #364553;
							font-size: 16px;
						}

						.cliente-vendedor-vazio span {
							font-size: 13px;
						}

						@media (max-width: 767px) {

							.content-header {
								padding: 12px 15px;
							}

							.content {
								padding: 10px;
							}

							.cliente-vendedor-acoes {
								align-items: stretch;
								flex-direction: column;
							}

							.cliente-vendedor-acoes .btn {
								width: 100%;
								min-height: 46px;
								border-radius: 10px;
								font-size: 14px;
								font-weight: 600;
							}

							.cliente-vendedor-filtros {
								padding: 12px;
								border-radius: 12px;
							}

							.cliente-vendedor-filtros-datas {
								flex-direction: column;
								align-items: stretch;
								gap: 0;
							}

							.cliente-vendedor-filtro-data {
								width: 100%;
							}

							.cliente-vendedor-filtro-botao {
								width: 100%;
								padding-bottom: 0;
								margin-top: 4px;
							}

							.cliente-vendedor-filtro-botao .btn {
								width: 100%;
								min-height: 44px;
								border-radius: 10px;
							}

							.cliente-vendedor-pesquisa input {
								height: 46px;
								font-size: 16px;
							}

							.cliente-vendedor-tabela-desktop {
								display: none;
							}

							.cliente-vendedor-cards-mobile {
								display: flex;
								flex-direction: column;
								gap: 12px;
							}

							.cliente-vendedor-card-mobile {
								padding: 14px;
								background: #fff;
								border: 1px solid #e3e9ef;
								border-radius: 14px;
								box-shadow: 0 3px 12px rgba(31, 45, 61, 0.07);
								cursor: pointer;
								transition: transform 0.15s ease, box-shadow 0.15s ease;
								-webkit-tap-highlight-color: transparent;
							}

							.cliente-vendedor-card-mobile:active {
								transform: scale(0.985);
								box-shadow: 0 1px 5px rgba(31, 45, 61, 0.08);
							}

							.cliente-vendedor-card-topo {
								display: flex;
								align-items: flex-start;
								justify-content: space-between;
								gap: 10px;
							}

							.cliente-vendedor-card-numero {
								display: flex;
								align-items: center;
								gap: 7px;
								margin-bottom: 5px;
								color: #263746;
								font-size: 15px;
								font-weight: 700;
							}

							.cliente-vendedor-card-numero i {
								color: #3c8dbc;
							}

							.cliente-vendedor-card-data {
								display: flex;
								align-items: center;
								gap: 6px;
								color: #788795;
								font-size: 12px;
							}

							.cliente-vendedor-card-divisor {
								height: 1px;
								margin: 12px 0;
								background: #edf1f4;
							}

							.cliente-vendedor-card-nome {
								display: flex;
								align-items: center;
								gap: 10px;
								margin-bottom: 11px;
							}

							.cliente-vendedor-card-nome > i {
								display: flex;
								align-items: center;
								justify-content: center;
								width: 34px;
								height: 34px;
								border-radius: 10px;
								background: #edf5fb;
								color: #3c8dbc;
								flex-shrink: 0;
							}

							.cliente-vendedor-card-nome > div {
								display: flex;
								flex-direction: column;
								min-width: 0;
							}

							.cliente-vendedor-card-label {
								margin-bottom: 1px;
								color: #8794a0;
								font-size: 10px;
								font-weight: 600;
								text-transform: uppercase;
							}

							.cliente-vendedor-card-nome strong {
								overflow: hidden;
								color: #263746;
								font-size: 14px;
								text-overflow: ellipsis;
								white-space: nowrap;
							}

							.cliente-vendedor-card-info {
								display: flex;
								align-items: center;
								gap: 8px;
								margin-top: 7px;
								color: #667684;
								font-size: 12px;
							}

							.cliente-vendedor-card-info i {
								width: 16px;
								color: #99a5b0;
								text-align: center;
							}

							.cliente-vendedor-card-rodape {
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-top: 13px;
								padding-top: 10px;
								border-top: 1px solid #edf1f4;
								color: #84919d;
								font-size: 11px;
								font-weight: 600;
							}

							.cliente-vendedor-card-rodape i {
								color: #3c8dbc;
							}

							.cliente-vendedor-resumo {
								margin-top: 14px;
							}
						}
					`}
				</style>

				<ContentCard>
					<div className="cliente-vendedor-acoes">
						<div className="cliente-vendedor-btn-adicionar">
							<Button
								text="Adicionar contrato"
								type="success"
								icon="fa fa-plus"
								event={this.adicionar}
							/>
						</div>
					</div>

					<div className="cliente-vendedor-filtros">
						<div className="cliente-vendedor-filtros-datas">
							<div className="cliente-vendedor-filtro-data">
								<LabelAndInputMask
									label="Data Inicial"
									placeholder="Informe a data inicial"
									mask="99/99/9999"
									cols="12 12 12 12"
									value={this.props.filtro.dataInicial}
									onChange={event => {
										this.props.setFiltro({
											...this.props.filtro,
											dataInicial: event.target.value
										});
									}}
								/>
							</div>

							<div className="cliente-vendedor-filtro-data">
								<LabelAndInputMask
									label="Data Final"
									placeholder="Informe a data final"
									mask="99/99/9999"
									cols="12 12 12 12"
									value={this.props.filtro.dataFinal}
									onChange={event => {
										this.props.setFiltro({
											...this.props.filtro,
											dataFinal: event.target.value
										});
									}}
								/>
							</div>

							<div className="cliente-vendedor-filtro-botao">
								<Button
									text="Atualizar"
									type="primary"
									icon="fa fa-sync"
									event={() => {
										this.props.getLista(true);
									}}
								/>
							</div>
						</div>

						<div className="cliente-vendedor-pesquisa">
							<i className="fa fa-search" />

							<input
								className="form-control"
								placeholder="Pesquisar por nome, número, CPF ou telefone"
								type="text"
								value={this.state.pesquisar}
								onChange={event => {
									this.setState({
										pesquisar: event.target.value
									});
								}}
							/>

							{this.state.pesquisar &&
								<button
									type="button"
									className="cliente-vendedor-pesquisa-limpar"
									title="Limpar pesquisa"
									onClick={() => {
										this.setState({
											pesquisar: ''
										});
									}}
								>
									<i className="fa fa-times" />
								</button>
							}
						</div>
					</div>

					<div className="cliente-vendedor-resumo">
						<span>
							{lista.length === 1
								? '1 cliente encontrado'
								: `${lista.length} clientes encontrados`}
						</span>
					</div>

					{lista.length > 0 ? (
						<>
							{this.renderTabelaDesktop(lista)}
							{this.renderCardsMobile(lista)}
						</>
					) : (
						this.renderListaVazia()
					)}
				</ContentCard>
			</>
		);
	};

	render() {
		return (
			<div>
				<ContentHeader
					title="Contrato"
					small="Cadastro"
				/>

				<Content>
					{this.props.modoTela === 'visualizacao' &&
						<Form visualizar />
					}

					{this.props.modoTela === 'reservarCliente' &&
						<Form
							reservarCliente
							onSubmit={this.props.reservarCliente}
						/>
					}

					{this.props.modoTela === 'cadastro' &&
						<Form onSubmit={this.props.salvar} />
					}

					{this.props.modoTela === 'exclusao' &&
						<Form
							excluir
							onSubmit={this.props.excluir}
						/>
					}

					{this.props.modoTela === 'lista' &&
						this.lista()
					}
				</Content>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		sessao: state.auth.usuario,
		modoTela: state.clienteVendedor.modoTela,
		lista: state.clienteVendedor.lista,
		filtro: state.clienteVendedor.filtro,
		listaUsuario: state.clienteVendedor.listaUsuario,
		listaCidade: state.clienteVendedor.listaCidade
	};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela,
	initForm,
	salvar,
	excluir,
	reservarCliente,
	getLista,
	setFiltro,
	getRegistro,
	getListaClienteTipo,
	getListaClienteStatus,
	getListaEstadoCivil,
	getListaFormaPagamento,
	getListaOperadoraTelefonica,
	getListaTipoContrato,
	getListaUsuario,
	getListaEstado,
	getListaCidade
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ClienteVendedor);